import type { EasyVrpMapContext } from './EasyVrpMapContext';
import { writable } from 'svelte/store';

export const mapContext = writable<EasyVrpMapContext | null>(null);
